import { render, staticRenderFns } from "./RecomendedSlider.vue?vue&type=template&id=89d53430&"
import script from "./RecomendedSlider.vue?vue&type=script&lang=js&"
export * from "./RecomendedSlider.vue?vue&type=script&lang=js&"
import style0 from "./RecomendedSlider.vue?vue&type=style&index=0&id=89d53430&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports